import { render, staticRenderFns } from "./agentFlowTopUpOrder.vue?vue&type=template&id=963fd81c&scoped=true&"
import script from "./agentFlowTopUpOrder.vue?vue&type=script&lang=js&"
export * from "./agentFlowTopUpOrder.vue?vue&type=script&lang=js&"
import style0 from "./agentFlowTopUpOrder.vue?vue&type=style&index=0&id=963fd81c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963fd81c",
  null
  
)

export default component.exports